import {PaletteOptions} from '@material-ui/core/styles/createPalette';

import {foundations} from '../../foundation';
import {colors} from '../../foundation/colors';
import '../mui-styles';

export const palette: PaletteOptions = {
  type: 'light',
  common: {
    white: colors.white,
    black: colors.black,
  },
  primary: {
    light: foundations.legacy.primaryLight,
    main: foundations.legacy.primary,
    dark: foundations.legacy.primaryDark,
    contrastText: colors.white,
  },
  secondary: {
    light: colors.gray[400],
    main: colors.gray[600],
    dark: colors.gray[800],
    contrastText: colors.black,
  },
  success: {
    light: foundations.legacy.successLight,
    main: foundations.legacy.success,
    dark: foundations.legacy.successDark,
    contrastText: colors.black,
  },
  error: {
    light: foundations.legacy.error,
    main: foundations.legacy.error,
    dark: foundations.legacy.error,
    contrastText: colors.black,
  },
  info: {
    light: foundations.legacy.infoLight,
    main: foundations.legacy.info,
    dark: foundations.legacy.infoDark,
    contrastText: colors.black,
  },
  warning: {
    light: foundations.legacy.warningLight,
    main: foundations.legacy.warning,
    dark: foundations.legacy.warningDark,
    contrastText: colors.black,
  },
  red: {
    light: foundations.colors.red[400],
    // These two resolved to undefined in @wandb/ui 0.1.0 (legacy.red is a
    // string, not a shade map); kept as-is so MUI fills in the same defaults.
    main: (foundations.legacy.red as any)[600],
    dark: (foundations.legacy.red as any)[800],
    contrastText: colors.black,
  },
  text: {
    primary: colors.gray[800],
    // Also undefined in @wandb/ui 0.1.0 (there is no colors[600]).
    secondary: (colors as any)[600],
    disabled: colors.gray[400],
  },
  grey: colors.gray,
};
